// extracted by mini-css-extract-plugin
export default {"messageContainer":"vf_vg","messageContainer_drawer":"vf_vh","message":"vf_cA","simulated":"vf_vi","cancelled":"vf_vj"};